import React from "react";
import SignalDcIcon from "img/signal_disconnected.svg";
import { T } from "services/lang/LanguageService";

interface ISparkLineDisconnectedLabelProps {
  isMultipleCharts?: boolean;
  isLoading?: boolean;
}

const SparkLineDisconnectedLabel = ({ isMultipleCharts, isLoading }: ISparkLineDisconnectedLabelProps) => {
  if (isLoading) return null;

  return (
    <div className="flex align-items-end justify-content-center gap-2">
      <img src={SignalDcIcon} alt="" width={24} />
      {!isMultipleCharts && T("label.disconnected")}
    </div>
  );
};

export default SparkLineDisconnectedLabel;
